/**
 * Serviço de Tópicos
 * Comunicação com o backend para obter lista de especialidades (topics)
 */

import { env } from '../config/env';

export interface Topic {
  id: number;
  name: string;
  createdAt: string;
  updatedAt: string;
}

/**
 * Busca todos os tópicos disponíveis
 */
export async function getAllTopics(): Promise<Topic[]> {
  try {
    const response = await fetch(`${env.apiBaseUrl}/topics`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    });

    if (!response.ok) {
      throw new Error('Erro ao buscar especialidades');
    }

    const topics: Topic[] = await response.json();
    return topics;
  } catch (error) {
    if (error instanceof Error) {
      throw error;
    }
    throw new Error('Erro ao conectar com o servidor');
  }
}
